const badgeStyle = () => ({
	icon: {
		width: 'auto',
	},
	lg: {
		height: '88px',
	},
	rg: {
		height: '46px',
	},
	sm: {
		height: '32px',
	},
});

export default badgeStyle;
